import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WhereUsedItemDto } from './where-used-item.dto';

@Injectable({ providedIn: 'root' })
export class WhereUsedProvider {
  constructor(private http: HttpClient) {}

  getWhereUsed(bomItemId: number): Observable<WhereUsedItemDto[]> {
    const url = `/api/bom/${bomItemId}/where-used`;
    return this.http.get<WhereUsedItemDto[]>(url);
  }
}
